import { Accordion } from "flowbite-react"
const ECommerceFAQ: React.FC = () => {
  return (
    <>
      <Accordion>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What is E-commerce?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              E-commerce is short form for electronic commerce, which means
              buying and selling of products or services over the internet. It
              involves online transactions between businesses and consumers,
              making it possible to shop for and purchase a wide range of goods
              and services without physical interaction.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            {" "}
            What kind of e-commerce development services do you provide?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              We offer a comprehensive range of e-commerce development services
              to cater to your unique business needs. Our services include
              custom e-commerce development, platform-based e-commerce
              development, mobile e-commerce app development, e-commerce website
              design, e-commerce consulting, e-commerce integrations, e-commerce
              migration, and ongoing e-commerce support and evolution.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            Which platforms do you use for e-commerce website development?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              We have expertise in a variety of E-commerce platforms, including
              Shopify, WooCommerce (WordPress), Magento, BigCommerce, and more.
              Our team selects the platform that best suits your business model
              and requirements.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            How much does an e-commerce website cost?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The cost of developing an e-commerce website varies based on
              several factors, including the complexity of your project, desired
              features, and the platform chosen. We offer personalized quotes
              after discussing your specific needs and goals to ensure
              transparency and accuracy in pricing.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What are the benefits of hiring e-commerce web developers?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Hiring e-commerce web developers offers numerous advantages. Our
              experts bring extensive experience and knowledge to the table,
              ensuring your project is executed efficiently and with a deep
              understanding of e-commerce trends. We also provide timely
              support, maintenance, and updates, keeping your online store at
              its best and ensuring a seamless shopping experience for your
              customers.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            Will I get support from you after the e-commerce website is
            developed?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Yes, we are committed to providing ongoing support after your
              e-commerce website is developed. Our dedicated support team is
              here to assist you with any issues, updates, or optimizations to
              ensure your e-commerce platform continues to perform at its peak
              and remains competitive in the dynamic online marketplace. Your
              success is our priority, and we&apos;ll be with you every step of
              the way.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            Will I get dedicated resources for my project?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Yes, when you collaborate with us, you will benefit from:
              <br />
              <ul className="list mt-3 mb-3">
                <li>A dedicated team focused completely on your project.</li>
                <li>Tailored solutions aligned with your goals.</li>
                <li>Timely delivery and open communication.</li>
                <li>Stringent quality assurance processes.</li>
              </ul>
              Being a leading e-commerce development agency, we are committed to
              providing dedicated resources for your project&apos;s success.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </>
  )
}

export default ECommerceFAQ
